export const FACTORY = 'Factory';
//# sourceMappingURL=factory.js.map